export default {
  containerProps: {
    class: 'ma-0',
  },
  fieldProps: {
    outlined: true,
    dense: true,
  },
};
